import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

export function EquipmentBlock(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const pluggedInAria = () => {
    return props.pluggedIn ? t('CablesPluggedIn.string') : t('CablesNotPluggedIn.string')
  }
  
  return <div aria-label={pluggedInAria()} tabindex="0" className={props.className}>{props.children}</div>;
}

EquipmentBlock.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
EquipmentBlock.defaultProps = {
  className: '',
};
